var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTogether(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 211.001,
    viewBox: "0 0 300 211.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -514.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H0A44,44,0,0,1,44,44V85a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(256 598.999)",
    fill: "#ffe8cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H83a0,0,0,0,1,0,0V0A42,42,0,0,1,41,42H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(173 684)",
    fill: "#ffe8cd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    transform: "translate(173 514.999)",
    fill: "#ffe8cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,0h0a0,0,0,0,1,0,0V86a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V43A43,43,0,0,1,43,0Z",
    transform: "translate(0 596.999)",
    fill: "#ffe8cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H0A44,44,0,0,1,44,44V86a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(129 596.999)",
    fill: "#ffe8cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H86a0,0,0,0,1,0,0V0A43,43,0,0,1,43,43H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(43 683)",
    fill: "#ffe8cd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    transform: "translate(46 515.999)",
    fill: "#ffe8cd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTogether);
export default __webpack_public_path__ + "static/media/together.43bd3f54.svg";
export { ForwardRef as ReactComponent };